









import Vue from 'vue';
import store from '@/store';
import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus';
import { PageInternalNav } from '@/components/page-components';
import { CTA, MemberDependentResponseModel, MemberPaymentMethodsResponseModel } from '../../@types/member';

export default Vue.extend({
  name: 'PaymentAndBanking',
  beforeRouteEnter(to, from, next) {
    const promises = [
      store.dispatch('getPaymentMethods'),
      store.dispatch('getDependents'),
      store.dispatch('getAccounts'),
    ];
    LoadingService.watchPromises(promises)
      .then((data) => {
        const paymentMethods = data[0];
        let suppressDebitCardSection = true,
          suppressCrossoverSection = true,
          suppressPaymentMethodScreen,
          childPageRedirect;

        if (typeof paymentMethods.canHaveCards !== 'undefined') {
          suppressDebitCardSection = !paymentMethods.canHaveCards;
          suppressCrossoverSection =
            !paymentMethods.canHaveMedicalCrossover &&
            !paymentMethods.canHaveDentalCrossover;
        }

        suppressPaymentMethodScreen =
          suppressDebitCardSection && suppressCrossoverSection;
        to.meta.suppressPaymentMethodScreen = suppressPaymentMethodScreen;
        childPageRedirect = suppressPaymentMethodScreen
          ? 'bankAccounts'
          : 'paymentMethod';

        if (to.name === 'bankAccounts') {
          next();
        } else {
          next((vm) => {
            vm.$router.replace({ name: childPageRedirect });
          });
        }
      })
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  computed: {
    navItems(): CTA[] {
      const items: CTA[] = [
        {
          to: { name: 'bankAccounts' },
          text: [
            'payment-banking_menu-item_bank-accounts',
            'global_bank-accounts',
          ],
          icon: 'icon-banking',
        },
      ];
      if (!this.$route.meta.suppressPaymentMethodScreen) {
        items.unshift({
          to: { name: 'paymentMethod' },
          text: [
            'payment-banking_menu-item_payment-method',
            'global_payment-method',
          ],
          icon: 'credit_card',
        });
      }
      return items;
    },
    paymentMethods(): MemberPaymentMethodsResponseModel {
      return this.$store.getters.paymentMethods;
    },
    dependents(): MemberDependentResponseModel[] {
      return this.$store.getters.dependents;
    },
    showDebitCardSection(): boolean {
      return this.paymentMethods.canHaveCards;
    },
    showCrossoverSection(): boolean {
      return (
        this.paymentMethods.canHaveMedicalCrossover ||
        this.paymentMethods.canHaveDentalCrossover
      );
    },
    suppressPaymentMethodScreen(): boolean {
      return !this.showDebitCardSection && !this.showCrossoverSection;
    },
  },
  beforeRouteUpdate(to, from, next) {
    to.meta.suppressPaymentMethodScreen = this.suppressPaymentMethodScreen;
    if (to.name === 'paymentAndBanking' && this.suppressPaymentMethodScreen) {
      this.$router.replace({ name: 'bankAccounts' });
    } else {
      next();
    }
  },
  components: {
    PageInternalNav,
  },
});
